module.exports = __webpack_public_path__ + "lp/img/pencil_icon.cad012e6.svg";